import React, {useState, useEffect} from 'react'
import RecordTop from "./record-components/RecordTop"
import SelectCate from "./record-components/SelectCate"
import RecordTable from "./record-components/RecordTable"

import { db } from "../config/firebase"

const Records = () => {

   const [records, setRecords] = useState([{}])
   const [renderUniv, setRenderUniv] = useState(true)

   let cate
   if (renderUniv) {
      cate = "univRecords"
   } else if (!renderUniv) {
      cate = "hsRecords"
   }

   useEffect(() => {
      db.collection(cate)
         .onSnapshot((snapShot) => {
            const list = snapShot.docs.map((doc) => {
               const content = doc.data()
               content.id = doc.id
               return content
            })
            const asc = (n, m) => {
               return n.order - m.order
            }
            setRecords(list.sort(asc))
         })
      }, [renderUniv])

   return (
      <>
         <RecordTop/>
         <SelectCate
            renderUniv={renderUniv}
            setRenderUniv={setRenderUniv}
            />
         <RecordTable
            records={records}
         />
      </>
   )
}

export default Records